import { render, staticRenderFns } from "./VueRepeaterDropZoneLocal.vue?vue&type=template&id=184f673a&scoped=true&"
import script from "./VueRepeaterDropZoneLocal.vue?vue&type=script&lang=js&"
export * from "./VueRepeaterDropZoneLocal.vue?vue&type=script&lang=js&"
import style0 from "./VueRepeaterDropZoneLocal.vue?vue&type=style&index=0&id=184f673a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "184f673a",
  null
  
)

export default component.exports